<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Jefe from "../../views/evaluaciones/evaluacion-jefedepartamento";
import Profesor from "../../views/evaluaciones/evaluacion-profesorjefe";
import Encargado from "../../views/evaluaciones/evaluacion-encargadoconvivencia";
import Docente from "../../views/evaluaciones/evaluacion-docente";
import Coordinador from "../../views/evaluaciones/evaluacion-coordinadoracademico";
import Auxiliar from "../../views/evaluaciones/evaluacion-auxiliar";
import Asistente from "../../views/evaluaciones/evaluacion-asistenteeducacion";
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Jefe, Profesor, Encargado, Docente, Coordinador, Auxiliar, Asistente },
    data() {
        return {
            title: "Evaluaciones",
            items: [
                {
                text: "Utility",
                href: "/"
                },
                {
                text: "Starter Page",
                active: true
                }
            ],
            users:[],
            proceso:[],
            usuario:'',
            instrumento:{},
            retroalimentacion:'',
            colegios:'',
            filtro:{
                colegio:''
            },
        };
    },
    methods:{
        abrir_retroalimentacion(usuario){
            this.usuario = usuario;
            this.user_evaluar={
                id: usuario.id,
                nombre: usuario.nombre,
                apellidoPaterno :usuario.apellidoPaterno,
                apellidoMaterno: usuario.apellidoMaterno
            };
            this.instrumento.nombre=usuario.instrumento;
            this.retroalimentacion=usuario.encuesta_retro;
            //console.log(usuario);
            this.$refs['modal-retroalimentacion'].show()
        },
        actualizar(){
            if (this.user.rol_id==1) {
                axios.get('/api/get_colegios').then(res=>{
                    this.colegios = res.data.colegios;
                });
            }
            else if (this.user.rol_id==2) {
                this.filtro.colegio=this.user.colegio_id;
                this.buscar();
            }
        },
        buscar(){
            axios.get('/api/get_instrumentos_colegio/'+this.filtro.colegio).then(res=>{
                this.users = res.data.users;
            });
        },
    },
    created(){
        this.actualizar();
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="card p-3 mt-2 bg-soft-primary" v-if="user.rol_id==1">
                            <div class="row">
                                <div class="offset-md-2 col-md-6">
                                    <div class="form-group row">
                                        <label class="col-md-3 pt-1 font-size-16 text-right">Colegio :</label>
                                        <div class="col-md-9">
                                            <select class="custom-select" v-model="filtro.colegio" @change="buscar()">
                                                <option disabled value="">Seleccione colegio</option>
                                                <option v-for="colegio in colegios" :key="colegio.id" :value="colegio.id">{{colegio.nombre.toUpperCase()}} ({{colegio.comuna_nombre}} - {{colegio.region_nombre}})</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-2 text-right">
                                    <b-button variant="primary" block @click="buscar()">Buscar</b-button>
                                </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-md-12">
                                <div class="table-responsive">
                                    <table class="table table-hover mb-0">
                                        <thead>
                                            <tr>
                                                <th>Nº</th>
                                                <th>Nombre </th>
                                                <th>Correo</th>
                                                <th>Instrumento</th>
                                                <th>Autoevaluación</th>
                                                <th>Coevaluación</th>
                                                <th>Evaluación Jefe</th>
                                                <th>Retroalimentación</th>
                                                <th>Acciones</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(usuario,index ) in users" :key="index">
                                                <th>{{index+1}}</th>
                                                <td>{{usuario.nombre}} {{usuario.apellidoPaterno}} {{usuario.apellidoMaterno}}</td>
                                                <td>{{usuario.email}}</td>
                                                <td>{{usuario.instrumento}}</td>
                                                <td>
                                                    <p v-if="usuario.autoevaluacion=='No aplica'">{{usuario.autoevaluacion}}</p>
                                                    <p v-else-if="usuario.autoevaluacion==true" class="p-1 bg-success text-white" style="border-radius:0.25rem">Contestada</p>
                                                    <p v-else-if="usuario.autoevaluacion==false" class="p-1 bg-danger text-white" style="border-radius:0.25rem">No Contestada</p>
                                                </td>
                                                <!-- <td ><b-button variant="transparent" :id="'popover-target-'+index">60%</b-button></td>
                                                <b-popover :target="'popover-target-'+index" triggers="hover" placement="top">
                                                    <template #title>Autoevaluación</template>
                                                    <p>I. Competencias funcionales: 60%</p>
                                                    <p>II. Competencias conductuales: 60%</p>
                                                    <p>III. Competencias cognitivas: 60%</p>
                                                </b-popover> -->
                                                <td>
                                                    <p v-if="usuario.coevaluacion=='No aplica'">{{usuario.coevaluacion}}</p>
                                                    <div v-else>
                                                        <p v-if="usuario.coevaluacion.encuesta" class="p-1 bg-success text-white" style="border-radius:0.25rem">Contestada</p>
                                                        <p v-else class="p-1 bg-danger text-white" :id="'popover-co-'+index" style="border-radius:0.25rem">No Contestada</p>
                                                        <b-popover :target="'popover-co-'+index" triggers="hover" placement="top">
                                                            <template #title>Coevaluación</template>
                                                            <div v-for="(usuario,index) in usuario.coevaluacion.users" :key="index">
                                                                <p v-if="usuario.encuesta==true">{{usuario.nombre}} {{usuario.apellidoPaterno}}: Contestada</p>
                                                                <p v-else>{{usuario.nombre}} {{usuario.apellidoPaterno}}: No Contestada</p>
                                                            </div>
                                                        </b-popover>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p v-if="usuario.jefe=='No aplica'">{{usuario.jefe}}</p>
                                                    <div v-else>
                                                        <p v-if="usuario.jefe.encuesta" class="p-1 bg-success text-white" style="border-radius:0.25rem">Contestada</p>
                                                        <p v-else class="p-1 bg-danger text-white" :id="'popover-jefe-'+index" style="border-radius:0.25rem">No Contestada</p>
                                                        <b-popover :target="'popover-jefe-'+index" triggers="hover" placement="top">
                                                            <template #title>Nombre del Jefe</template>
                                                            <p>{{usuario.jefe.nombre}} {{usuario.jefe.apellidoPaterno}}</p>
                                                        </b-popover>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p v-if="usuario.retro=='No aplica'">{{usuario.retro}}</p>
                                                    <div v-else>
                                                        <p v-if="usuario.retro.encuesta" class="p-1 bg-success text-white text-center" style="border-radius:0.25rem">Contestada</p>
                                                        <p v-else class="p-1 bg-danger text-white" :id="'popover-retro-'+index" style="border-radius:0.25rem">No Contestada</p>
                                                        <b-popover :target="'popover-retro-'+index" triggers="hover" placement="top">
                                                            <template #title>Nombre del Encargado</template>
                                                            <p>{{usuario.retro.nombre}} {{usuario.retro.apellidoPaterno}}</p>
                                                        </b-popover>
                                                    </div>
                                                </td>
                                                <td>
                                                    <b-button variant="primary" @click="abrir_retroalimentacion(usuario)" v-if="usuario.instrumento!='' && usuario.autoevaluacion==true">Ver Informe</b-button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <b-modal ref="modal-retroalimentacion" size="xl" :title="'Observaciones '+usuario.nombre+' '+usuario.apellidoPaterno+' '+usuario.apellidoMaterno" ok-title="Guardar" ok-only>
                                    <Jefe :user_evaluar="user_evaluar" v-if="instrumento.nombre=='Jefe de Departamento'" :retro='true'/>
                                    <Profesor :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Profesor Jefe'" :retro='true'/>
                                    <Encargado :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Encargado de Convivencia'" :retro='true'/>
                                    <Docente :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Docente'" :retro='true'/>
                                    <Coordinador :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Coordinadores'" :retro='true'/>
                                    <Auxiliar :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Auxiliar'" :retro='true'/>
                                    <Asistente :user_evaluar="user_evaluar" v-else-if="instrumento.nombre=='Asistente de la Educación'" :retro='true'/>
                                    <b-form-group id="example text" label="Retroalimentación" label-for="text">
                                        <b-form-textarea id="textarea" v-model="retroalimentacion" placeholder="Ingresar Retroalimentación..." rows="3" max-rows="6" disabled></b-form-textarea>
                                    </b-form-group>
                                </b-modal>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>